import apiClient from './apiClient';

export async function listCoupons(params = {}) {
  const { data } = await apiClient.get('/api/admin/coupons', { params });
  return data;
}

export async function createCoupon(payload) {
  const { data } = await apiClient.post('/api/admin/coupon', payload);
  return data;
}

export async function updateCoupon(id, payload) {
  const { data } = await apiClient.put(`/api/admin/coupon/${id}`, payload);
  return data;
}

export async function deleteCoupon(id) {
  const { data } = await apiClient.delete(`/api/admin/coupon/${id}`);
  return data;
}
